import { render, staticRenderFns } from "./PartnerDetail.vue?vue&type=template&id=47d06aa0"
import script from "./PartnerDetail.vue?vue&type=script&lang=js"
export * from "./PartnerDetail.vue?vue&type=script&lang=js"
import style0 from "./PartnerDetail.vue?vue&type=style&index=0&id=47d06aa0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports